import React, {useMemo} from "react";
import Stepper from "../../../../../../../components/app-specific/stepper";
import {Box} from "@mui/material";
import {ImportingSteps} from "../../types";


const ImportingViewStepperSection = ({state, setStep, updatingStep}) => {

    const steps = useMemo(() => {
        const result = [
            {id: ImportingSteps.selectDataSource},
            {id: ImportingSteps.mapColumns},
            {id: ImportingSteps.review},
            {id: ImportingSteps.importing},
        ]
        const defaultLabels = {
            [ImportingSteps.selectDataSource]: 'Select Data Source',
            [ImportingSteps.mapColumns]: 'Map Columns',
            [ImportingSteps.review]: 'Review',
            [ImportingSteps.importing]: 'Import',
        }
        const stepsDisabledStatus = {
            [ImportingSteps.selectDataSource]: state.step === ImportingSteps.importing,
            [ImportingSteps.mapColumns]: state.step === ImportingSteps.importing || !state.importedFile,
            [ImportingSteps.review]: state.step === ImportingSteps.importing || !state.apiRequests,
            [ImportingSteps.importing]: !state.apiRequests,
        }
        return result.map(e => ({
            id: e.id,
            label: defaultLabels[e.id],
            disabled: stepsDisabledStatus[e.id] || updatingStep,
        }));
    }, [state.importedFile, state.apiRequests, state.step, updatingStep])

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
            <Stepper
                steps={steps}
                activeStepId={state.step}
                onClicked={setStep}
                className={'w-75 my-5'}
                disableActiveLinesAtLast={true}
            />
        </Box>
    );
};

export default ImportingViewStepperSection;
